
export default {
    name: "popup_lobby_video",
    props: ["videoUrl"],
    data(){
        return {

        }
    },
    computed: {

    },
    mounted(){
        
    },
    methods: {
        onClickCloseBtn(){
            this.$emit("update:currentPopupItem", null);

            this.$store.dispatch('auth/onTriggerAnalytics', { 
                event: "click_event", 
                action: `close@lobby_video`, 
                route: this.$route.path
            });
        }
    }
}
